var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"overlay fixed top-0 left-0",class:[_vm.colour, _vm.size],attrs:{"id":_vm.id}},[(_vm.close)?_c('div',{staticClass:"close",on:{"click":_vm.back}},[_c('svg-close')],1):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }